const createUniqueId = function createUniqueIdHelper(...ids) {
  return ids.reduce((id, argument) => (id + argument), '')
    .replace(/(\s)/g, '')
    .toLowerCase();
};


export default createUniqueId;
